<template>
  <div class="middle-box text-center loginscreen">
    <div>
      <h3>{{ $t("message.welcome") }}</h3>
      <el-form
        style="margin: 30px 0px 0 0px"
        class="m-t"
        role="form"
        :model="loginForm"
        ref="loginForm"
        @submit.native.prevent="checkEvent"
      >
        <div class="form-group">
          <el-input
            v-model="loginForm.username"
            placeholder="Username"
          ></el-input>
        </div>
        <div class="form-group">
          <el-input
            type="password"
            v-model="loginForm.password"
            placeholder="Password"
          ></el-input>
        </div>
        <div class="form-group">
          <div class="has-error" v-show="hasErrorMsg">{{ errorMsg }}</div>
        </div>
        <el-button class="full-width m-b" type="primary" native-type="submit">{{
          $t("message.Login")
        }}</el-button>

        <router-link
          to="/forgetPassword"
          style="padding-top: 20px; display: block"
        >
          <small>Forgot password? </small>
        </router-link>
      </el-form>
      <p class="m-t">
        <small>CP &copy; {{ year }}</small>
      </p>
    </div>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import sha256 from "sha256";
export default {
  mixins: [config.globalMixin],
  name: "loginController",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      username: "",
      password: "",
      hasErrorMsg: true,
      errorMsg: "",
      year: "shijian",
    };
  },
  created: function () {
    var date = new Date();
    this.year = date.getFullYear();
  },
  methods: {
    checkEvent() {
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          return false;
        }
      });
    },
    async login(e) {
      let setLogin = {
        account: this.loginForm.username,
        pwd: sha256(this.loginForm.password),
      };
      var self = this;
      var data = await this.$store.dispatch("login", setLogin);
      if (data) {
        this.$store.state.userInfo.language = data.data.result.langs;
        let assembleFunction = function (parentObj, list) {
          for (var i = 0; i < list.length; i++) {
            var childObj = list[i];
            if (parentObj.id == childObj.parentId) {
              if (parentObj.children) {
                parentObj.children.push(childObj);
              } else {
                parentObj.children = [];
                parentObj.children.push(childObj);
              }
              assembleFunction(childObj, list);
            }
          }
        };

        let systemFuncs = data.data.result.systemFuncs;
        var rootObj = { id: 0 };
        assembleFunction(rootObj, systemFuncs);
        this.$store.state.userInfo.systemFuncs = rootObj.children;
        this.$store.state.userInfo.langCode = "en_US";
        sessionStorage.setItem(
          "userInfo",
          JSON.stringify(this.$store.state.userInfo)
        );
        const schoolPortalFuncs = systemFuncs.find((i) => {
          return i.id == 157;
        });
        var isRoute = false;
        const schoolRequestFuncs =
          schoolPortalFuncs &&
          schoolPortalFuncs.children &&
          schoolPortalFuncs.children.length
            ? schoolPortalFuncs.children.find((i) => {
                return i.id == 165;
              })
            : null;
        if (
          this.$store.state.userInfo.roleType == 6 &&
          schoolRequestFuncs &&
          schoolRequestFuncs.webInfo
        ) {
          if (!isRoute) {
            isRoute = true;
            self.$router.push({ path: schoolRequestFuncs.webInfo });
          }
        } else {
          systemFuncs.forEach(function (item) {
            if (item.webInfo && !isRoute) {
              isRoute = true;
              self.$router.push({ path: item.webInfo });
            }
          });
        }
      }
    },
  },
  mounted() {
    this.$store.commit("login", "");
    sessionStorage.clear();
    eventBus.$on(
      "warningBtn",
      function () {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
      }.bind(this)
    );
  },
};
</script>

<style scoped></style>
